module.exports = __webpack_public_path__ + "img/antes_despues_60.ae57286e.png";